import { OPERATOR_SCORECARD_STATS_MOCK } from './operator-scorecard.mock';
import { applyScorecardPeriod } from './operator-scorecard.period';
import type {
  DashboardPeriod,
  OperatorScorecardStatsDto,
} from './operator-scorecard.types';

/**
 * Operator scorecard stats.
 *
 * Today: typed mock so the UI is wired like a real API consumer.
 * Later: replace `getStats` with fetch / generated client — keep the DTO
 * and pass `period` as a query param.
 */
export const OperatorScorecardService = {
  async getStats(
    _organizationId: string,
    period: DashboardPeriod,
  ): Promise<OperatorScorecardStatsDto> {
    await new Promise((resolve) => setTimeout(resolve, 150));
    return applyScorecardPeriod(
      structuredClone(OPERATOR_SCORECARD_STATS_MOCK),
      period,
    );
  },
};
